import { handleGenericApiError } from "app/api/error";
import UserRequests from "app/api/user";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_USERS = "user:ACTION_SAVE_USERS";
export const ACTION_SAVE_USER = "user:ACTION_SAVE_USER";
export const ACTION_TOGGLE_USER_ACTIVE = "user:ACTION_TOGGLE_USER_ACTIVE";
// export const ACTION_SET_SELECTED_USER = "user:ACTION_SET_SELECTED_USER";

export const ACTION_SAVE_USER_CHANGE_HISTORIC =
  "user:ACTION_SAVE_USER_CHANGE_HISTORIC";

export const fetchPartnerUsers = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await UserRequests.fetchPartnerUsers(params);
    dispatch({ type: ACTION_SAVE_USERS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchUserById = id => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await UserRequests.fetchUserById(id);
    dispatch({ type: ACTION_SAVE_USER, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const createUser = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await UserRequests.createUser(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateUser = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await UserRequests.updateUser(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const disableUser = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await UserRequests.disableUser(id);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const setUserActive = id => async dispatch => {
  dispatch(addLoading());
  try {
    await UserRequests.toggleUser(id);
    dispatch({ type: ACTION_TOGGLE_USER_ACTIVE, payload: id });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadUsersPartner = params => async () => {
  try {
    const response = await UserRequests.downloadUsersPartner(
      params.searchParameter
    );
    const link = document.createElement("a");
    link.href = response.data;
    link.setAttribute("download", "usuarios-partner.csv");
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const fetchAllUserHistoric = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await UserRequests.fetchAllUserHistoric(params);
    dispatch({ type: ACTION_SAVE_USER_CHANGE_HISTORIC, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
export const fetchUserHistoricByDate = params => async dispatch => {
  dispatch(addLoading());
  try {
    return await UserRequests.fetchUserHistoricByDate(params);
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
export const fetchUserHistoricById = params => async dispatch => {
  dispatch(addLoading());
  try {
    return await UserRequests.fetchUserHistoricById(params);
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
